import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  palette: {
    primary: {
      main: "#279f76",
      dark: '#1d7959',
      light: '#7cc2aa',
    },

    secondary: {
      main: "#dbf5ec",
    },

    error: {
      main: "#f44336",
    },

    // New gray palette
    grey: {
      50: "#fafafa",
      100: "#f5f5f5",
      200: "#eeeeee",
      300: "#e0e0e0",
      400: "#bdbdbd",
      500: "#9e9e9e",
      600: "#757575",
      700: "#616161",
      800: "#424242",
      900: "#212121",
      A100: "#f5f5f5",
      A200: "#eeeeee",
      A400: "#bdbdbd",
      A700: "#616161",
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          // Common styles for all Button variants
        },
        contained: {
          // Styles specific to contained variant
          backgroundColor: "#279f76",
          color: "#ffffff",
          "&:hover": {
            backgroundColor: "#218c65",
          },
        },
        outlined: {
          "&:hover": {
            color: "#ffffff",
            borderColor: "#f44336",
            backgroundColor: "#f44336",
          },
        },
        text: {
          // Styles specific to text variant
          color: "#279f76",
          "&:hover": {
            backgroundColor: "rgba(39, 159, 118, 0.04)", // Light hover effect
          },
        },
      },
    },
  },
  typography: {
    h6: {
      fontWeight: 700,
    },

    subtitle1:{
      color: "#6d6c6c",
      fontWeight: 600,
    },

    subtitle2:{
      color: "#707273"
    }
  },
});

export default theme;
